import { FC } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';

type SelectionRadioProps = PropsWithClassName<{
  label: string;
  selected: boolean;
  onClick: () => void;
}>;

const SelectionRadio: FC<SelectionRadioProps> = ({ label, selected, onClick, className }) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'flex items-center justify-between w-full px-4 py-3.5 rounded-2xl border text-sm font-dm transition-all',
      selected ? 'border-black border-2' : 'border-black/20',
      className
    )}
  >
    <span className={cn('text-black', selected ? 'font-medium' : '')}>{label}</span>
    <div
      className={cn(
        'w-5 h-5 rounded-full border-2 flex-shrink-0',
        selected ? 'bg-black border-black' : 'border-black/30'
      )}
    />
  </button>
);

export default SelectionRadio;
